// extracted by mini-css-extract-plugin
export default {"option":"autocomplete_option__97BGl","paper":"autocomplete_paper__MNJCY","groupLabel":"autocomplete_groupLabel__jhV2M","tag":"autocomplete_tag__ZsUIK"};